import styled from 'styled-components';
import { marginStyle } from '../../const/helpers';
import { IconProps } from './types';
import { colors } from '../../const/color';
import { displayHelperStyle } from '../../const/display';

const IconStyled = styled.span<IconProps>`
  width: ${({ $size }) => `${$size}px`};
  height: ${({ $size }) => `${$size}px`};
  align-items: center;
  ${({ $display }) => $display && displayHelperStyle($display)};
  margin: ${({ $m }) => ($m ? `${$m.map(m => marginStyle(m)).join(' ')} !important` : '0')};
  * {
    fill: ${({ $color }) => colors[$color]};
  }
`;

export default IconStyled;
